import { toNumber } from 'lodash'
import { DSP_KEY_LABELS } from '@/utils/constants'

const helpers = {
    buildRoutes: () => {
        const route = '/audience_admin/dsps.json'
        const params = {
            params: {
                conditions: { status: [{ '!=': 'deleted' }] }
            }
        }
        return { route, params }
    },

    parseData: data => {
        const _data = []
        for (const val of data) {
            if (val.key_label !== DSP_KEY_LABELS.videology) {
                const wamData = {
                    id: toNumber(val.id),
                    label: val.label,
                    isSelectable: false,
                    hasChild: true,
                    parentJsonKeyName: null,
                    keyLabel: val.key_label,
                    jsonKey: {
                        ids: [toNumber(val.id)],
                        name: 'dsp_' + val.id,
                        type: 'dsp',
                        subType: null
                    }
                }
                _data.push(wamData)
            }
        }
        return _data.sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
    }
}

export default helpers
